module.exports = __webpack_public_path__ + "img/pauli-x-root-21.b1cb2571.svg";